import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: ${({ theme }) => `${theme.space.xs} 0px ${theme.space.xs} 0px`};

  svg {
    color: ${({ theme }) => theme.palette.warning100};
  }
`
